import {
  Component,
  ChangeDetectionStrategy,
  input,
  ElementRef,
} from '@angular/core';
import { NgClass } from '@angular/common';

// todo: full refactor
@Component({
  selector: 'fc-tooltip-inline',
  standalone: true,
  template: `
    <div class="relative inline-block">
      <div
        class="fc-tooltip-content w-max max-w-xs rounded-lg bg-secondary-900 px-12 py-8 text-xs text-grey-100 shadow-lg"
      >
        @if (text()) {
          {{ text() }}
        } @else {
          <ng-content></ng-content>
        }
      </div>

      @if (showArrow() && position()) {
        <div
          class="pointer-events-none absolute size-12 rotate-45 bg-secondary-900 shadow-lg -z-1"
          [ngClass]="arrowClasses(position())"
        ></div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class TooltipInlineComponent {
  showArrow = input<boolean>(true);
  position = input<'top' | 'bottom' | 'left' | 'right'>('top');
  target = input<HTMLElement | ElementRef<HTMLElement>>();
  offset = input<number>(8);
  text = input<string | null>(null);

  arrowClasses(position: 'top' | 'bottom' | 'left' | 'right'): string[] {
    switch (position) {
      case 'top':
        // Tooltip above the target → arrow on bottom center
        return ['-bottom-1.5', 'left-1/2', '-translate-x-1/2'];
      case 'bottom':
        // Tooltip below the target → arrow on top center
        return ['-top-1.5', 'left-1/2', '-translate-x-1/2'];
      case 'left':
        // Tooltip to the left → arrow on right center
        return ['-right-1.5', 'top-1/2', '-translate-y-1/2'];
      case 'right':
      default:
        // Tooltip to the right → arrow on left center
        return ['-left-1.5', 'top-1/2', '-translate-y-1/2'];
    }
  }
}
